import ConditionalRuleSet from "../../../../common/models/conditionalRules/conditionalRuleSet";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import FormElementConditionalRule from "./formElementConditionalRule";
import WorkflowStepActionJumpTo from "../workflow/workflowStepActionJumpTo";
import WorkflowStepActionJumpToFactory from "../workflow/workflowStepActionJumpToFactory";
import {ConditionalFieldDefinition} from "../../../../common/models/conditionalRules/conditionalFieldDefinition";

export default class FormElementConditionalRuleSet extends ConditionalRuleSet {
  static repo: IRepo<FormElementConditionalRuleSet> = new Repo<FormElementConditionalRuleSet>('conditionalRuleSets', FormElementConditionalRuleSet);

  constructor(fieldName: string, definition: ConditionalFieldDefinition) {
    super(fieldName, definition);
    this.except.push('form');
  }

  createNew(fieldName: string, conditionalFieldDefinition: ConditionalFieldDefinition): FormElementConditionalRuleSet {
    return new FormElementConditionalRuleSet(fieldName, conditionalFieldDefinition);
  }

  createNewRule(): FormElementConditionalRule {
    return new FormElementConditionalRule();
  }

  get jump_to(): WorkflowStepActionJumpTo {
    if (this.conditional_value instanceof WorkflowStepActionJumpTo) {
      return this.conditional_value;
    } else{
      return null;
    }
  }

  set jump_to(val: WorkflowStepActionJumpTo) {
    this.conditional_value = val;
  }

  get jump_to_client_id(): string {
    if (this.jump_to) {
      return this.jump_to.to_client_id;
    } else {
      return null;
    }
  }

  set jump_to_client_id(val: string) {
    if (this.parent instanceof WorkflowStepActionJumpTo) {
      if (!this.jump_to) {
        this.jump_to = WorkflowStepActionJumpToFactory.create(this);
      }
      this.jump_to.to_client_id = val;
    } else {
      console.error('Cannot assign jump_to_client_id when parent is not an action');
    }
  }
}